// extracted by mini-css-extract-plugin
export default {"datesWrapper":"dates_datesWrapper__zjN3E"};